import { css } from '@emotion/css';
import { actImageUrl, commonGenresStyle } from 'Shared/frontend/eventPosters/MusicPoster';
import { combinedGenres } from 'Shared/common/Macros';
import { Show } from 'solid-js';
import { nameStyle, maxTextLines} from 'Shared/frontend/Poster';
import { poster } from 'Shared/frontend/SettingsProvider';


export function ThreeActs(P)
{
	const s = () => P.posterSettings;
	const theme = () => poster(s().theme,'threeActs');
	
	const posterStyle = () => css(theme().contents,{
		width: '100%',
	});

	const imageStyle = () => css(theme().img);

	const imageWrapStyle = () => css(theme().imageWrap,{
		width: 150,
		lineHeight: '0',
		img: {
			width: '100%',
			display: 'block',
		},
	});

	const artist1ImageStyle = () => css(imageWrapStyle(),{
		float: 'left',
	})

	const artist2ImageStyle = () => css(imageWrapStyle(),{
		float: 'right',
		marginTop: '-42px',
		zIndex: '1',
		position: 'relative',
	});

	const artist3ImageStyle = () => css(imageWrapStyle(), {
		float: 'left',
		marginTop: '-42px',
		zIndex: '1',
		position: 'relative',
	});

	const detailsStyle = () => css({
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		height: '101px', // pushes genres to bottom of poster
	});

	const eventNameArtistNameStyle = () => css({
		padding: '.5em 0 .5em 0',
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'center',
		alignContent: 'center',
		height: '-webkit-fill-available',
		fontSize: '1em',
	});

	const eventNameStyle = () => css(nameStyle(), {
		width: '100%',
		marginBottom: '0.5em',
		...maxTextLines(2),
		fontSize: s().nameFontSize ?? theme().name.fontSize
	});

	const artistNameStyle = () => css(theme().artistNames, {
		fontSize: s().artistNamesFontSize ?? theme().artistNames.fontSize
	});

	const genresStyle = () => css(commonGenresStyle(), theme().genres,{
		width: '100%',
		whiteSpace: 'normal', // we're grouping data so needs to be overridden from commonGenreStyle
	});


	const hide = () => s()?.hide ?? [];
	const showName = () => P.name && ! s().hide?.includes('name');

	return (
		<div class={posterStyle()}>
			<div class={artist1ImageStyle()}><img class={imageStyle()} src={actImageUrl(P.lineup[0].image)}  height={100} /></div>
			<div class={artist2ImageStyle()}><img class={imageStyle()} src={actImageUrl(P.lineup[1].image)}  height={100} /></div>
			<div class={artist3ImageStyle()}><img class={imageStyle()} src={actImageUrl(P.lineup[2].image)}  height={100} /></div>

			<div style='clear:both' />

			<div class={detailsStyle()}>
				<div class={eventNameArtistNameStyle()}>
					<Show when={showName()}>
						<div class={eventNameStyle()}>{ P.name }</div>
					</Show>

					<Show when={!hide().includes('artistName')}>
						<div class={artistNameStyle()}>
							{P.lineup[0].name}{', '}
							{P.lineup[1].name}{' & '}
							{P.lineup[2].name}
						</div>
					</Show>
				</div>
				<div class={genresStyle()}>
					<Show when={!hide().includes('artistGenres')}>
						{ combinedGenres(P.lineup) }
					</Show>
				</div>
			</div>
		</div>
	);
}

